import { useQuery } from '@tanstack/react-query'
import { useCallback } from 'react'
import { StoryType } from '~/widgets/Stories'
import { Story } from '~/shared/api'

export const QUERY_KEY_STORIES = 'stories'

export const useLoadStories = () => {
  const fetchStories = useCallback(async (): Promise<StoryType[]> => {
    const builder = Story.limit(50)
      .orderBy('sort')
      .with('posts')
      .where('isActive', 'true')

    const response = await builder.get(1)

    const data = response.getData()

    return data.map((story: Story) => {
      const posts = story?.getPosts()

      return {
        id: story.getApiId() as UniqueId,
        title: story.getTitle(),
        content: story.getContent(),
        img: story.getImage(),
        posts: (posts || []).map((post) => ({
          id: post.getApiId() as UniqueId,
          title: post.getTitle(),
          description: post.getDescription(),
          content: post.getContent(),
          img: post.getImage(),
          externalLink: post.getExternalLink(),
        })),
      }
    })
  }, [])

  const { isFetching, data = [] } = useQuery(
    [QUERY_KEY_STORIES],
    () => fetchStories(),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 3 * 60 * 1000,
    },
  )

  return { data, isFetching }
}
